// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7a0268f1","455":"3633f11a"}[chunkId] + ".chunk.js";
};